import { render, staticRenderFns } from "./FAQCreate.vue?vue&type=template&id=4210e338&scoped=true&"
import script from "./FAQCreate.vue?vue&type=script&lang=js&"
export * from "./FAQCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210e338",
  null
  
)

export default component.exports